<template>
  <div
    :class="[
      'newspark-header-main-menu',
      darkClass && 'menuItem' in darkClass ? darkClass.menuItem : '',
    ]"
  >
    <ul v-if="nav_items" :class="{ 'lang-en-mode': $i18n.locale === 'en' }">
      <!-- 一级菜单 -->
      <li v-for="(item, index) in nav_items" :key="index" :class="{ 'lang-en-wrap': $i18n.locale === 'en' }">
        <!-- 🔥 有子菜单时，使用 span -->
        <span
          v-if="item.child"
          :class="[
            'menu-parent',
            { 'lang-en-wrap': $i18n.locale === 'en' },
            { 'menu-active': activeMenuId === item.id }
          ]"
        >
          {{ $t(item.linkText) }}
          <!-- <i class="fal fa-angle-down"></i> -->
        </span>

        <!-- 🔥 无子菜单时，使用 a 标签 -->
        <a
          v-else
          href="javascript:void(0)"
          :class="[
            { 'lang-en-wrap': $i18n.locale === 'en' },
            { 'menu-active': activeMenuId === item.id }
          ]"
          @click="handleLinkClick(item.link)"
        >
          {{ $t(item.linkText) }}
        </a>

        <!-- 🔥 二级菜单 -->
        <ul v-if="item.child" class="sub-menu" :class="{ 'sub-en-wide': $i18n.locale === 'en' }">
          <li v-for="(lvlTwo, index) in item.submenu" :key="index" :class="{ 'lang-en-wrap': $i18n.locale === 'en' }">
            <a
              href="javascript:void(0)"
              class="menu-link"
              @click="handleAnchorClick(lvlTwo.link)"
            >
              {{ $t(lvlTwo.linkText) }}
            </a>
            <!-- 三级菜单 -->
            <ul v-if="lvlTwo.child" class="sub-menu">
              <li v-for="(lvlThree, index) in lvlTwo.third_menu" :key="index" :class="{ 'lang-en-wrap': $i18n.locale === 'en' }">
                <a
                  href="javascript:void(0)"
                  class="menu-link"
                  @click="handleAnchorClick(lvlThree.link)"
                >
                  {{ $t(lvlThree.linkText) }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <!-- 语言切换 -->
      <li class="lang-switch-wrap">
        <span class="lang-trigger">
          {{ $t('lang.current') }}
          <i class="fal fa-angle-down"></i>
        </span>
        <ul class="sub-menu lang-sub">
          <li @click="changeLocale('zh-cn')">{{ $t('lang.zh') }}</li>
          <li @click="changeLocale('en')">{{ $t('lang.en') }}</li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import navItems from "../../Data/NavItems.json";
import { eventBus } from '@/utils/eventBus.js';

export default {
  props: {
    darkClass: {
      type: Object,
    },
  },
  data: () => ({
    nav_items: navItems.data,
    currentLang: localStorage.getItem('locale') || 'zh-cn',
    activeMenuId: null
  }),
  watch: {
    $route: {
      handler() {
        this.calcActiveMenu();
      },
      immediate: true
    }
  },
  methods: {
    changeLocale(lang) {
      if (this.currentLang === lang) return;
      this.currentLang = lang;
      localStorage.setItem('locale', lang);
      this.$i18n.locale = lang;
      eventBus.$emit('language-changed', lang);
    },
    calcActiveMenu() {
      const currentPath = this.$route.path;
      const hashName = this.$route.hash.replace('#', '');
      
      // 定义需要特殊处理的路径映射
      const specialPathMap = {
        '/register': 'menu.register',
        '/manuscript': 'menu.submitPaper'
      };
      
      // 🔥 先检查特殊路径匹配
      for (const [pathPrefix, menuKey] of Object.entries(specialPathMap)) {
        if (currentPath.startsWith(pathPrefix)) {
          const matchedItem = this.nav_items.find(item => item.linkText === menuKey);
          if (matchedItem) {
            this.activeMenuId = matchedItem.id;
            return;
          }
        }
      }
      
      for (const item of this.nav_items) {
        if (!item.child) {
          const targetUrl = new URL(item.link, window.location.origin);
          const targetPath = targetUrl.pathname;
          
          if (targetPath === '/' && currentPath === '/') {
            if (this.$route.hash) continue;
            this.activeMenuId = item.id;
            return;
          }
          if (targetPath !== '/' && currentPath === targetPath) {
            this.activeMenuId = item.id;
            return;
          }
        } else {
          const parentUrl = new URL(item.link, window.location.origin);
          const parentPath = parentUrl.pathname;
          const subPaths = item.submenu.map(sub => {
            const subUrl = new URL(sub.link, window.location.origin);
            return subUrl.pathname;
          });
          
          if (
            currentPath === parentPath ||
            subPaths.includes(currentPath) ||
            (currentPath === '/' && ['brief', 'guest', 'schedule', 'org'].includes(hashName))
          ) {
            this.activeMenuId = item.id;
            return;
          }
        }
      }
      this.activeMenuId = null;
    },
    // 🔥 处理普通链接点击
    handleLinkClick(link) {
      if (!link) return;

      if (link.startsWith('#')) {
        this.handleAnchorClick(link);
        return;
      }

      const cleanPath = link.split('?')[0].split('#')[0] || '/';

      // 🔥 如果是首页，发送 clear-hash-and-scroll 事件
      if (cleanPath === '/') {
        eventBus.$emit('clear-hash-and-scroll');
        this.$router.replace({
          path: '/',
          query: {},
          hash: ''
        }).catch(err => {
          console.warn('路由跳转失败:', err);
        });
        return;
      }

      this.$router.push({
        path: cleanPath,
        query: {},
        hash: ''
      }).catch(err => {
        console.warn('路由跳转失败:', err);
      });
    },
    // 🔥 处理锚点点击
    handleAnchorClick(link) {
      if (link && link.startsWith('#')) {
        // 阻止默认行为
        event.preventDefault();

        // 更新 URL 但不触发滚动
        const fullUrl = window.location.pathname + link;
        window.history.pushState({}, '', fullUrl);

        // 延迟通知父组件滚动，确保 URL 已更新
        this.$nextTick(() => {
          eventBus.$emit('scroll-to-anchor', link);
        });
      } else if (link) {
        this.$router.push(link);
      }
    }
  }
};
</script>

<style>
/* ========== 一级导航 ========== */
.newspark-header-main-menu ul {
  display: flex;
  gap: 40px;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

/* 🔥 英文模式：调整间距 */
.newspark-header-main-menu ul.lang-en-mode {
  gap: 26px;
}

.newspark-header-main-menu ul > li {
  white-space: nowrap;
  position: relative;
}

/* 🔥 英文模式：允许换行，但不拆分单词 */
.newspark-header-main-menu ul.lang-en-mode > li {
  white-space: normal;
  max-width: 140px;
}

.newspark-header-main-menu ul > li > a,
.newspark-header-main-menu ul > li > span.menu-parent {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  line-height: 45px;
  position: relative;
  padding: 8px 0;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
}

/* 🔥 英文模式：菜单文字换行 - 保留完整单词 */
.newspark-header-main-menu ul.lang-en-mode > li > a,
.newspark-header-main-menu ul.lang-en-mode > li > span.menu-parent {
  white-space: normal !important;
  word-break: keep-all !important;  /* 不拆分单词 */
  overflow-wrap: break-word;
  line-height: 1.3;
  padding: 4px 0;
  font-size: 16px;
  text-align: center;
  max-width: 100%;
}

/* 🔥 英文模式：父菜单（带子菜单的）也允许换行 */
.newspark-header-main-menu ul.lang-en-mode > li > span.menu-parent {
  display: inline-block;
  text-align: center;
  white-space: normal !important;
  word-break: keep-all !important;
  overflow-wrap: break-word;
}

/* 🔥 父菜单 hover 样式 */
.newspark-header-main-menu ul > li > span.menu-parent:hover {
  color: #74b1f4;
}

/* ========= 菜单激活样式 ========= */
.newspark-header-main-menu ul > li > a.menu-active,
.newspark-header-main-menu ul > li > span.menu-parent.menu-active {
  color: #74b1f4;
}

.newspark-header-main-menu ul > li > a.menu-active::after,
.newspark-header-main-menu ul > li > span.menu-parent.menu-active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background-color: #74b1f4;
}

.newspark-header-main-menu ul > li > a:hover,
.newspark-header-main-menu ul > li > span.menu-parent:hover {
  color: #74b1f4;
}

/* ========== 下拉箭头 ========== */
.newspark-header-main-menu ul > li > span.menu-parent i {
  margin-left: 6px;
  font-size: 14px;
}

/* ========== 下拉容器 ========== */
.newspark-header-main-menu ul > li .sub-menu {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 110%;
  min-width: 130px;
  max-width: 130px;
  background-color: #7784bc;
  opacity: 0;
  visibility: hidden;
  transition: all linear 0.3s;
  z-index: 99;
  box-shadow: 11px 10px 38px 0 rgba(46, 63, 99, 0.15);
  padding: 15px 0;
  border-radius: 8px;
}

/* 🔥 英文模式：下拉菜单宽度自适应 */
.newspark-header-main-menu ul.lang-en-mode > li .sub-menu {
  min-width: 160px;
  max-width: 200px;
}

.newspark-header-main-menu ul > li:hover .sub-menu {
  opacity: 1;
  visibility: visible;
}

.newspark-header-main-menu .sub-menu {
  display: block !important;
}

.newspark-header-main-menu .sub-menu li {
  list-style: none;
  padding: 14px 0;
  text-align: center;
  display: block;
  border-bottom: none !important;
}

/* 🔥 英文模式：二级菜单文字不拆分单词 */
.newspark-header-main-menu ul.lang-en-mode .sub-menu li {
  white-space: normal;
  padding: 10px 16px;
}

.newspark-header-main-menu ul.lang-en-mode .sub-menu .menu-link {
  white-space: normal !important;
  word-break: keep-all !important;
  overflow-wrap: break-word;
  font-size: 15px;
  line-height: 1.4;
}

/* ========== 二级菜单 ========== */
.menu-link {
  color: #ffffff !important;
  font-size: 20px;
  text-decoration: none !important;
  display: inline-block !important;
  padding: 0 10px;
  white-space: nowrap;
  position: relative;
  cursor: pointer;
}

/* 🔥 英文模式：菜单链接不拆分单词 */
.newspark-header-main-menu ul.lang-en-mode .menu-link {
  white-space: normal !important;
  word-break: keep-all !important;
  overflow-wrap: break-word;
  font-size: 15px;
  line-height: 1.4;
  padding: 0 4px;
}

.menu-link:hover {
  color: #74b1f4 !important;
}

.menu-link::after {
  content: "" !important;
  position: absolute !important;
  left: 0 !important;
  bottom: -4px !important;
  width: 100% !important;
  height: 2px !important;
  background-color: #ffffff !important;
  transition: background-color 0.2s ease !important;
}

.menu-link:hover::after {
  background-color: #74b1f4 !important;
}

.newspark-header-main-menu.header-two ul > li > a {
  color: #ffffff;
}

.newspark-header-main-menu.header-three-nav ul > li > a {
  color: white;
}

.header-three-nav {
  margin-left: 35px;
}

/* ========== 语言切换 ========== */
.newspark-header-main-menu ul > li.lang-switch-wrap {
  position: relative;
  white-space: nowrap;
  cursor: pointer;
  min-width: 72px;
  text-align: center;
}

/* 🔥 英文模式：语言切换不换行 */
.newspark-header-main-menu ul.lang-en-mode > li.lang-switch-wrap {
  white-space: nowrap;
}

.newspark-header-main-menu .lang-trigger {
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  line-height: 45px;
  padding: 8px 0;
  display: inline-block;
}

.newspark-header-main-menu .lang-trigger i {
  margin-left: 6px;
  font-size: 14px;
}

.newspark-header-main-menu ul > li.lang-switch-wrap:hover .lang-trigger {
  color: #74b1f4;
}

.newspark-header-main-menu ul > li.lang-switch-wrap .lang-sub {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 110%;
  min-width: 100px;
  max-width: 100px;
  background-color: #7784bc;
  opacity: 0;
  visibility: hidden;
  transition: all linear 0.3s;
  z-index: 99;
  box-shadow: 11px 10px 38px 0 rgba(46, 63, 99, 0.15);
  padding: 12px 0;
  border-radius: 8px;
}

.newspark-header-main-menu ul > li.lang-switch-wrap:hover .lang-sub {
  opacity: 1;
  visibility: visible;
}

.newspark-header-main-menu .lang-sub li {
  list-style: none;
  padding: 12px 0;
  text-align: center;
  font-size: 18px;
  color: #fff;
  transition: color 0.2s;
  cursor: pointer;
}

.newspark-header-main-menu .lang-sub li:hover {
  color: #74b1f4;
}

/* ========== 响应式 ========== */
@media (max-width: 1200px) {
  .newspark-header-main-menu ul {
    gap: 24px;
  }
  
  .newspark-header-main-menu ul.lang-en-mode {
    gap: 12px;
  }
  
  .newspark-header-main-menu ul.lang-en-mode > li {
    max-width: 100px;
  }
  
  .newspark-header-main-menu ul.lang-en-mode > li > a,
  .newspark-header-main-menu ul.lang-en-mode > li > span.menu-parent {
    font-size: 13px;
  }
}

@media (max-width: 992px) {
  .newspark-header-main-menu ul.lang-en-mode {
    gap: 8px;
  }
  
  .newspark-header-main-menu ul.lang-en-mode > li {
    max-width: 80px;
  }
  
  .newspark-header-main-menu ul.lang-en-mode > li > a,
  .newspark-header-main-menu ul.lang-en-mode > li > span.menu-parent {
    font-size: 11px;
  }
}
</style>